var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.125a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.975 13.125a1.444 1.444 0 0 0 .289 1.592l.052.053a1.75 1.75 0 0 1-1.908 2.856 1.748 1.748 0 0 1-.568-.38l-.053-.052a1.444 1.444 0 0 0-1.592-.289 1.444 1.444 0 0 0-.875 1.321v.149a1.75 1.75 0 0 1-3.5 0v-.079a1.444 1.444 0 0 0-.945-1.321 1.444 1.444 0 0 0-1.593.289l-.052.052a1.75 1.75 0 1 1-2.476-2.476l.052-.053a1.443 1.443 0 0 0 .289-1.592 1.444 1.444 0 0 0-1.321-.875h-.149a1.75 1.75 0 0 1 0-3.5h.079a1.444 1.444 0 0 0 1.321-.945 1.444 1.444 0 0 0-.289-1.593l-.052-.052A1.75 1.75 0 1 1 6.16 3.754l.053.052a1.444 1.444 0 0 0 1.592.289h.07a1.444 1.444 0 0 0 .875-1.321v-.149a1.75 1.75 0 1 1 3.5 0v.079a1.444 1.444 0 0 0 .875 1.321 1.444 1.444 0 0 0 1.592-.289l.053-.052a1.75 1.75 0 0 1 2.856.568 1.75 1.75 0 0 1-.38 1.908l-.052.053a1.444 1.444 0 0 0-.289 1.592v.07a1.444 1.444 0 0 0 1.321.875h.149a1.75 1.75 0 0 1 0 3.5h-.079a1.444 1.444 0 0 0-1.321.875Z"
  }))));
};
export default SvgSettings;